export const scrollToElement = (id: string) => {
  const element = document.querySelector(id);
  if (element) {
    element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
};
